import { RefObject, useContext } from 'react';
import {
  Box,
  FilterProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  MarketingFilesProvider,
} from 'dash-ui';

import { PropertyPreviewParamsContext } from 'containers/properties/PropertyPreview/context/PropertyPreviewParamsContext';
import MarketingFiles from './components/MarketingFiles/MarketingFiles';

const MarketingFilesSection = ({
  containerRef,
  isAddedToMediaKit,
  showMediaKit,
  isPortfolioView = false,
}: {
  containerRef?: RefObject<HTMLDivElement>;
  isAddedToMediaKit?: boolean;
  showMediaKit?: boolean;
  isPortfolioView?: boolean;
}) => {
  const { params } = useContext(PropertyPreviewParamsContext);
  const { propertyId, portfolioFolderId } = params || {};
  return propertyId ? (
    <Box mt={8} mb={2} ref={containerRef}>
      <PaginationProvider perPage={16}>
        <SearchProvider>
          <FilterProvider>
            <SortProvider>
              <MarketingFilesProvider>
                <MarketingFiles
                  isPortfolioView={isPortfolioView}
                  propertyId={propertyId}
                  portfolioId={portfolioFolderId}
                  isAddedToMediaKit={isAddedToMediaKit}
                  showMediaKit={showMediaKit}
                />
              </MarketingFilesProvider>
            </SortProvider>
          </FilterProvider>
        </SearchProvider>
      </PaginationProvider>
    </Box>
  ) : null;
};

export default MarketingFilesSection;
